<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Milestones">
        <template #header>
            Milestones
        </template>
        <div class="dark:bg-gray-800 lg:dark:bg-gray-900 text-white lg:py-5 lg:px-6 lg:shadow transition duration-500 ease-in-out bg-white rounded-lg lg:border-2 border-gray-600 p-1 lg:p-4 m-4">
            <p class="text-center text-2xl font-semibold transition duration-500 ease-in-out text-white sm:text-gray-600 sm:dark:text-white col-span-1 md:col-span-2 pb-0 sm:pb-4">Milestones</p>
            <level-progress-bar class="flex mx-auto p-4 my-2"/>
            <small-progress-circle/>

        </div>
        <div class="dark:bg-gray-800 lg:dark:bg-gray-900 text-white lg:py-5 lg:px-6 lg:shadow transition duration-500 ease-in-out bg-white rounded-lg lg:border-2 border-gray-600 p-1 lg:p-4 m-4">
            <p class="text-center text-2xl font-semibold transition duration-500 ease-in-out text-white sm:text-gray-600
             sm:dark:text-white col-span-1 md:col-span-2 pb-0 sm:pb-4">
                Inventory
                <span class="align-top bg-purple-100 text-purple-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-purple-900 dark:text-purple-300">BETA</span>
            </p>
            <div class="items-center justify-center">
                <div class="grid gap-2 xl:gap-4 mt-2 p-0 lg:py-4 grid-cols-4">
                    <purchasedProduct />
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>

import AppLayout from '@/Layouts/Layout'
import VuePlayerVideo from 'vue3-player-video'
import LevelProgressBar from './Partials/LevelProgressBar.vue'
import SmallProgressCircle from './Partials/SmallProgressCircle.vue'
import Prize from './Partials/Prize.vue'
import { GiftIcon } from '@heroicons/vue/outline'
import Rewards from './Partials/Rewards.vue'
import purchasedProduct from './Partials/purchasedProduct.vue'


export default {
    props: {
        items: {
            type: Array,
            default: []
        }
    },

    setup(props) {

    },

    components: {
        AppLayout,
        VuePlayerVideo,
        LevelProgressBar,
        SmallProgressCircle,
        Prize,
        GiftIcon,
        Rewards,
        purchasedProduct
    },
}

</script>
